import { useMutation } from 'react-query';
import { postCampaign, CampaignPayload } from '../request';

export const usePostCampaign = () => {
  const { mutate, isLoading } = useMutation((payload: CampaignPayload) =>
    postCampaign(payload)
  );

  return { mutate, isLoading };
};
